import { createContext, useContext } from 'react';

export type LoginWithRedirectOptions = {
  appState?: { returnTo?: string };
};

export type LogoutOptions = {
  logoutParams?: {
    returnTo?: string;
  };
};

export type GetAccessTokenOptions = {
  cacheMode?: 'on' | 'off' | 'cache-only';
};

export type AuthContextType = {
  isAuthenticated: boolean;
  isLoading: boolean;
  loginWithRedirect: (options?: LoginWithRedirectOptions) => Promise<void>;
  logout: (options?: LogoutOptions) => void;
  getAccessTokenSilently: (options?: GetAccessTokenOptions) => Promise<string>;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth(): AuthContextType {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}

export default useAuth;
